import styled from '@emotion/styled';
import { colorPalettes, SIZES, Text } from '@linearb/linui-common';

const StyledText = styled(Text)`
  color: ${({ theme }) => colorPalettes[theme.palette.mode].alert.warning.text};
  margin-left: 1rem;
  font-size: ${SIZES['large']};
`;

export default StyledText;
